import { wsSocket } from "App";
import React, { useEffect } from "react";
import { Message } from "websocket/Socket";
import Consultant from "../models/Consultant";
import './ConsultantCard.scss';
import ConsultantRating from "./ConsultantRating";
import ConsultantStatus from "./ConsultantStatus";

interface Props {
    consultant: Consultant;
    clickUrl?: string;
    translations: { [ key: string ]: string };
    hideButtons?: boolean;
}

const ConsultantCard: React.FC<Props> = ( {
                                              hideButtons,
                                              clickUrl,
                                              consultant,
                                              translations
                                          }: Props ) => {

    useEffect( () => {
        try {
            wsSocket.addConnectHandler( () => {
                wsSocket.Send( new Message( undefined, { consultant: consultant.id } ) )
            } )
            wsSocket.Send( new Message( undefined, { consultant: consultant.id } ) )
        } catch ( e ) {
            // would be "not connected", we really don't care about that
        }
    }, [] );

    return <a href={ clickUrl } target={ "_parent" }>
        <article style={!hideButtons ? {} : {background: "#fff", marginBottom:"15px"}}>
            <img src={ consultant.profile.GetProfileImage() } alt={ consultant.profile.name }/>
            <div>
                <ConsultantStatus translations={ translations } status={ consultant.status }
                                  box={ consultant.box_number }/>
                <h1>{ consultant.profile.name }</h1>
                <ConsultantRating translations={ translations }
                                  rating={ consultant.average_rating ?? consultant.rating }
                                  count={ consultant.review_count }/>
                <p>{ consultant.profile.profile_translations[ 0 ].short_description }</p>

                { !hideButtons && <div className={ `buttons` }>
                    { consultant.call_enabled && <button>
                        { translations[ "partial.primary_actions.call" ] }
                        <br/>
                        <small>&euro; { ( consultant.call_rate / 100 ).toFixed( 2 ) } / min</small>
                    </button> }
                    { consultant.chat_enabled && <button>
                        { translations[ "partial.primary_actions.chat" ] }
                        <br/>
                        <small>&euro; { ( consultant.chat_rate / 100 ).toFixed( 2 ) } / min</small>
                    </button> }
                </div> }
            </div>
        </article>
    </a>;

}

export default ConsultantCard;